import React from "react";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class Notices extends React.Component {
    constructor(params) {
        super(params);
        this.toggleNotices = this.toggleNotices.bind(this);
        this.state = {
            showNotices: true,
            modalClassName: 'notices-modal',
            backdrop: 'static'
        };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Notices.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    toggleNotices() {
        const { hideNotices, notices, loggedIn } = this.props;
        if (this.state.showNotices) {
            hideNotices(notices, loggedIn ? types.NOTICES_LOGGED_IN_HIDE : types.NOTICES_NON_LOGGED_IN_HIDE);
            logUI("MBHWeb.Notifications.ShowHide", new Date(), Tools.getURLPath());
        }
        this.setState({
            showNotices: !this.state.showNotices
        });
    }

    render() {
        const { notices } = this.props;
        return (
            <React.Fragment>
                {notices && notices.length > 0 &&
                    (<div className="notices">
                        <Modal isOpen={this.state.showNotices} toggle={this.toggleNotices} centered={true} className={this.state.modalClassName} backdrop={this.state.backdrop}>
                        <ModalBody>
                            <div>{notices.map((notice, index) => <div key={index} dangerouslySetInnerHTML={{ __html: notice.noticeHTML + "<br />&nbsp;<br />" }} ></div>)}</div>
                        </ModalBody>
                        <ModalFooter><button className="btn btn-primary" onClick={() => this.toggleNotices()}>OK</button></ModalFooter>
                    </Modal></div>)
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loggedIn: state.domain.li,
        notices: state.domain.li
            ? state.header && state.header.loggedInNotices
            : state.header && state.header.nonLoggedInNotices
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        hideNotices: (notices, actionType) => dispatch({ type: actionType, notices: notices })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Notices);